export class CurrencyLookupModel {
	id: number;
	iso3: string;
	name: string;
	unitPerUsd: number;
	usdPerUnit: number;
	match: string;
}
